export const getDynamicColumnWidth = (
	categories: (string | number)[],
	containerSelector = '.chart-container',
): string => {
	const barsCount = categories.length
	const containerWidth =
		document?.querySelector(containerSelector)?.clientWidth || 1200

	const gap = 4
	const totalAvailable = containerWidth - barsCount * gap
	const rawWidth = totalAvailable / barsCount

	let maxPx = 60
	if (barsCount > 31) maxPx = 14
	else if (barsCount > 20) maxPx = 18
	else if (barsCount > 12) maxPx = 24
	else if (barsCount > 7) maxPx = 36

	const minPx = 4
	const columnWidth = Math.max(minPx, Math.min(maxPx, rawWidth))

	return `${columnWidth.toFixed(0)}px`
}
